import { render, staticRenderFns } from "./ChangePosturaPadrillo.vue?vue&type=template&id=44919400"
import script from "./ChangePosturaPadrillo.vue?vue&type=script&lang=js"
export * from "./ChangePosturaPadrillo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports